import { configureStore } from '@reduxjs/toolkit';
import time from './slices/timeSlice';
import weather from './slices/weatherSlice';
import ahwork from './slices/ahworkSlice';
import theme from './slices/themeSlice';
import todoist from './slices/todoistSlice';
import hassio from './slices/hassioSlice';

const store = configureStore({
  reducer: {
    time,
    weather,
    ahwork,
    theme,
    todoist,
    hassio,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['time.now'],
        ignoredActions: ['time/timerTick'],
      },
    }),
});

export default store;


